<template>
  <el-dialog
    v-bind="$attrs"
    v-model="self.isShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title>
      <div class="custom-title">
        {{ title }}
      </div>
    </template>
    <div class="content">
      <slot></slot>
    </div>
    <template #footer>
      <span class="dialog-footer" v-if="showBottomBtn">
        <slot name="beforeBtn"></slot>
        <el-button class="dialogfootbtn" @click="close">
          {{ closeBtnText || (readonly ? "关闭" : "取消") }}
        </el-button>
        <slot name="midBtn"></slot>
        <el-button
          type="primary"
          class="dialogfootbtn"
          v-if="!readonly"
          @click="submit"
        >
          {{ submitBtnText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import tool from "@/util/debounce";

export default {
  name: "pcDialog",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBottomBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    self: {
      type: Object,
      default: () => {},
      required: true,
    },
    //关闭按钮文字，默认根据readonly决定显示关闭或取消，传了优先取值
    closeBtnText: {
      type: String,
      required: false,
      default: "",
    },
    submitBtnText: {
      type: String,
      required: false,
      default: "保存",
    },
    title: {
      type: String,
      required: false,
    },
  },
  methods: {
    //关闭按钮
    close: tool._debouncefont(function () {
      const that = this;
      that.$emit("close");
    }, 1000),
    //提交按钮
    submit: tool._debouncefont(function () {
      const that = this;
      that.$emit("submit");
    }, 1000),
  },
};
</script>

<style lang="scss" scoped>

.custom-title {
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.dialog-footer {
  display: flex;
  justify-content: right;

}



</style>
